module.exports = __webpack_public_path__ + "media/images/icons/twotone/safety-certificate-1bb0d4dcd6ed74edc7ddbae5fe080593.svg";